<template>
  <div v-show="states.is_open" class="tw-fixed tw-left-0 tw-top-0 tw-w-full tw-h-full tw-bg-dark tw-bg-opacity-70 tw-overflow-auto tw-z-100" v-on:click.prevent="store.close()">
    <div class="tw-mx-6">
      <form v-on:submit.prevent="states.tab === 'login' ? store.login() : store.register()" class="tw-max-w-full md:tw-max-w-4xl tw-mx-auto tw-rounded tw-shadow-xl tw-my-16 tw-overflow-hidden" style="background: #fcfcfc" v-on:click.stop>
        <div class="tw-bg-gradient-to-r tw-from-primary tw-to-secondary tw-text-white tw-py-6 tw-px-6 tw-flex tw-items-center tw-justify-between tw-relative">
          <div class="tw-text-3xl tw-font-bold tw-relative tw-py-1 tw-rounded">
            <span class="tw-font-bold">{{store.titleText()}}</span>
          </div>
          <button type="button" v-on:click.prevent="() => store.close()" class="tw-w-10 tw-h-10 tw-rounded-full tw-flex tw-items-center tw-justify-center hover:tw-bg-red hover:tw-text-light">
            <i class="bx bx-x tw-text-4xl"></i>
          </button>
        </div>
        <!--
        <div class="tw-bg-gradient-to-r tw-from-primary tw-to-secondary tw-p-6 tw-flex tw-items-center tw-justify-between tw-text-light">
          <div class="tw-font-semibold tw-text-2xl">{{store.titleText()}}</div>
        </div>
        -->
        <div class="tw-space-y-5 tw-py-5 tw-w-full tw-p-10">
          <!--<div class="tw-py-4 tw-font-bold tw-text-xl tw-text-dark tw-text-opacity-75">{{store.helpText()}}</div>-->
          <template v-if="states.tab === 'login'">
            <label class="tw-w-full">
              <span class="tw-block tw-mb-2 tw-text-dark tw-text-opacity-50">Email Address:</span>
              <input v-model="states.login_form.email" type="text" class="tw-rounded tw-border tw-p-4 tw-w-full tw-text-center focus:tw-shadow-outline">
              <span class="tw-block tw-text-red tw-font-bold tw-mt-1" v-if="store.loginError('email')">{{store.loginError('email')}}</span>
            </label>
            <label class="tw-w-full">
              <span class="tw-block tw-mb-2 tw-text-dark tw-text-opacity-50">Password:</span>
              <input v-model="states.login_form.password" type="password" class="tw-rounded tw-border tw-p-4 tw-w-full tw-text-center focus:tw-shadow-outline">
              <span class="tw-block tw-text-red tw-font-bold tw-mt-1" v-if="store.loginError('password')">{{store.loginError('password')}}</span>
            </label>
          </template>
          <template v-else>
            <label class="tw-w-full">
              <span class="tw-block tw-mb-2 tw-text-dark tw-text-opacity-50">Firs Name:</span>
              <input v-model="states.register_form.first_name" type="text" class="tw-rounded tw-border tw-p-4 tw-w-full tw-text-center focus:tw-shadow-outline">
              <span class="tw-block tw-text-red tw-font-bold tw-mt-1" v-if="store.registerError('first_name')">{{store.registerError('first_name')}}</span>
            </label>
            <label class="tw-w-full">
              <span class="tw-block tw-mb-2 tw-text-dark tw-text-opacity-50">Last Name:</span>
              <input v-model="states.register_form.last_name" type="text" class="tw-rounded tw-border tw-p-4 tw-w-full tw-text-center focus:tw-shadow-outline">
              <span class="tw-block tw-text-red tw-font-bold tw-mt-1" v-if="store.registerError('last_name')">{{store.registerError('last_name')}}</span>
            </label>
            <label class="tw-w-full">
              <span class="tw-block tw-mb-2 tw-text-dark tw-text-opacity-50">Email Address:</span>
              <input v-model="states.register_form.email" type="text" class="tw-rounded tw-border tw-p-4 tw-w-full tw-text-center focus:tw-shadow-outline">
              <span class="tw-block tw-text-red tw-font-bold tw-mt-1" v-if="store.registerError('email')">{{store.registerError('email')}}</span>
            </label>
            <label class="tw-w-full">
              <span class="tw-block tw-mb-2 tw-text-dark tw-text-opacity-50">Phone Number:</span>
              <v-tel type="text" class="tw-form-input focus-within:tw-shadow-outline tw-bg-light tw-border-light-6" v-model="states.register_form.mobile_number" :enabledCountryCode="false" :dynamicPlaceholder="true" :inputOptions="{ showDialCode: true}"/>
              <!--<input v-model="states.register_form.mobile_number" type="text" class="tw-rounded tw-border tw-p-4 tw-w-full tw-text-center focus:tw-shadow-outline">-->
              <span class="tw-block tw-text-red tw-font-bold tw-mt-1" v-if="store.registerError('mobile_number')">{{store.registerError('mobile_number')}}</span>
            </label>
            <label class="tw-w-full">
              <span class="tw-block tw-mb-2 tw-text-dark tw-text-opacity-50">Password:</span>
              <input v-model="states.register_form.password" type="password" class="tw-rounded tw-border tw-p-4 tw-w-full tw-text-center focus:tw-shadow-outline">
              <span class="tw-block tw-text-red tw-font-bold tw-mt-1" v-if="store.registerError('password')">{{store.registerError('password')}}</span>
            </label>
          </template>
        </div>
        <div class="tw-p-10 tw-text-3xl tw-font-bold tw-flex tw-items-center tw-justify-between">
          <template v-if="states.tab === 'login'">
            <button class="tw-rounded tw-bg-secondary cursor:tw-bg-secondary-cursor tw-font-bold tw-py-5 tw-px-10 tw-text-2xl tw-text-center tw-text-light tw-flex tw-items-center">
              Login
              <i v-if="states.loading" class="bx bx-loader-alt tw-text-3xl bx-spin tw-ml-1"></i>
            </button>
            <div class="tw-text-xl tw-text-dark-3">
              <span class="">Have no account?</span>
              <button v-on:click.prevent="store.switchTab('register')" class="tw-inline-block tw-font-bold tw-text-2xl tw-text-blue">Sign Up</button>
              <span>here</span>
            </div>
          </template>
          <template v-else>
            <button class="tw-rounded tw-bg-secondary  cursor:tw-bg-secondary-cursor tw-font-bold tw-py-5 tw-px-10 tw-text-2xl tw-text-center tw-text-light">
              Sign Up
              <i v-if="states.loading" class="bx bx-loader-alt tw-text-3xl bx-spin"></i>
            </button>
            <div class="tw-text-xl tw-text-dark-3">
              <span class="">Already registered?</span>
              <button v-on:click.prevent="store.switchTab('login')" class="tw-inline-block tw-font-bold tw-text-2xl tw-text-blue">Login</button>
              <span>here</span>
            </div>
          </template>
        </div>
        <div class="tw-mx-5 tw-border-t tw-relative">
          <div style="background:#fcfcfc" class="tw-absolute tw-left-50pc tw-top-0 tw-px-4 tw-transform tw--translate-x-1/2 tw--translate-y-1/2">OR</div>
        </div>
        <div class="tw-p-10 tw-grid">
          <button type="button" v-on:click.prevent="openSocialite" class="tw-rounded tw-text-2xl tw-text-center tw-bg-red tw-shadow-md tw-text-white tw-font-bold tw-py-4 tw-px-5">
            {{states.tab === 'login' ? 'Login' : 'Sign up'}} With Google
            <!--<i class="fab fa-google tw-text-inherit tw-text-2xl" aria-hidden="true"></i>-->
          </button>
        </div>
        <!--
        <div class="tw-grid tw-gap-5 tw-grid-cols-2 tw-p-5">
          <button v-on:click="openSocialite" class="tw-rounded tw-bg-red tw-bg-opacity-75 cursor:tw-bg-opacity-100 tw-text-light tw-font-bold tw-text-center tw-py-4 tw-px-5">
            Login With Google
          </button>
          <button class="tw-rounded tw-bg-blue tw-bg-opacity-75 cursor:tw-bg-opacity-100 tw-text-light tw-font-bold tw-text-center tw-py-4 tw-px-5">
            Login With Facebook
          </button>
        </div>
        -->
      </form>
    </div>
  </div>
</template>
<script>
  import store from './auth-store'

  export default {
    props: {
      user: {
        default: null
      },
    },
    data: v => ({
      states: store.states
    }),
    created() {
      this.store = store
      store.states.user = this.user

      let openCallback = event => store.open(event.detail)

      this.$on('hook:mounted', () => document.addEventListener('open-auth', openCallback))
      this.$on('hook:beforeDestroy', () => document.removeEventListener('open-auth', openCallback))

      this.$watch(() => store.states.is_open, value => {
        if (value === true) {
          document.body.classList.add('tw-overflow-hidden')
        } else {
          document.body.classList.remove('tw-overflow-hidden')
        }
      })

      // Socialite Message Handler

      let messageHandler = e => {
        if (e.origin !== window.origin || _.get(e, 'data.success') !== true) {
          return;
        }
        console.log('socialite response', e.data)
        store.authenticated(e.data.user)
        Vue.$toast.success('You logged in successfully!');
      }

      window.addEventListener('message', messageHandler)
      this.$on('hook:beforeDestroy', () => window.removeEventListener('message', messageHandler))
    },
    methods: {
      openSocialite() {
        // const newWindow = this.openWindow('/login/google', 'message')
        window.location = '/login/google';
      },
      openWindow(url, title, options = {}) {
        if (typeof url === 'object') {
          options = url
          url = ''
        }

        options = {url, title, width: 600, height: 720, ...options}

        const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left
        const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top
        const width = window.innerWidth || document.documentElement.clientWidth || window.screen.width
        const height = window.innerHeight || document.documentElement.clientHeight || window.screen.height

        options.left = ((width / 2) - (options.width / 2)) + dualScreenLeft
        options.top = ((height / 2) - (options.height / 2)) + dualScreenTop

        const optionsStr = Object.keys(options).reduce((acc, key) => {
          acc.push(`${key}=${options[key]}`)
          return acc
        }, []).join(',')

        const newWindow = window.open(url, title, optionsStr)

        if (window.focus) {
          newWindow.focus()
        }

        return newWindow
      }
    }
  }
</script>
